export const TYPE_DE_BIEN = [
  { label: 'Appartements', id: 'Appartements' },
  { label: 'Maison', id: 'Maison' },
  { label: 'Terrain', id: 'Terrain' },
  { label: 'Parking', id: 'Parking' },
  { label: 'Garage', id: 'Garage' },
]

export const UTILISATION = [
  { label: 'Residence propriétaire', id: 'residence_propriétaire', value: 'Residence propriétaire' },
  { label: 'Location', id: 'location', value: 'Location' },
  { label: 'Professionnel', id: 'professionnel', value: 'Professionnel' },
  { label: 'Locatif', id: 'locatif', value: 'Locatif' },
]

export const CATEGORIE = [
  { label: 'Voyage', id:'1', value: 'Voyage'  },
  { label: 'Animaux', id:'2', value: 'Animaux'  },
  { label: 'Sports', id:'3', value: 'Sports'  },
  { label: 'Loisirs', id:'4', value: 'Loisirs'  },
  { label: 'Santé', id:'5', value: 'Santé'  },
  { label: 'Affaires', id:'6', value: 'Affaires'  },
  { label: 'Immobilier', id:'7', value: 'Immobilier'  },
  { label: 'Véhicules', id:'8', value: 'Véhicules'  },
  { label: 'Développement personnel', id:'9', value: 'Développement personnel'  },
  { label: 'Travail', id:'10', value: 'Travail'  },
  { label: 'Plaisirs', id:'11', value: 'Plaisirs'  },
  { label: 'Planète', id:'12', value: 'Planète'  },
  { label: 'Relation', id:'13', value: 'Relation'  },
  { label: 'Administration', id:'14', value: 'Administration'  },
]

export const TIMING_BUCKET = [
  { label: 'Dans 5 ans', id:1, value: 'Dans 5 ans' },
  { label: 'Dans 10 ans', id:2, value: 'Dans 10 ans' },
  { label: 'Dans 15 ans', id:3, value: 'Dans 15 ans' },
  { label: 'Dans 20 ans', id:4, value: 'Dans 20 ans' },
  { label: 'Dans 30 ans', id:5, value: 'Dans 30 ans' },
  { label: 'Dans 40 ans', id:6, value: 'Dans 40 ans' },
]

export const STATUT = [
  { label: 'à démarrer', id:1, value: 'à démarrer' },
  { label: 'En cours', id:2, value: 'En cours' },
  { label: 'Fait', id:3, value: 'Fait' },
]
